import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchCategory(params) {
  return await request({
    url: ENDPOINT.CAREER_CATEGORY,
    method: "get",
    params,
  });
}

export async function fetchCategoryById(id) {
  return await request({
    url: `${ENDPOINT.CAREER_CATEGORY}/${id}`,
    method: "get",
  });
}

export async function createCategory(data) {
  return await request({
    url: ENDPOINT.CAREER_CATEGORY,
    method: "post",
    data,
  });
}

export async function updateCategory(id, data) {
  return await request({
    url: `${ENDPOINT.CAREER_CATEGORY}/${id}`,
    method: "put",
    data,
  });
}

export async function removeCategory(id) {
  return await request({
    url: `${ENDPOINT.CAREER_CATEGORY}/${id}`,
    method: "delete",
  });
}